export default {
      id: "ic_arrow_up-usage",
      viewBox: "0 0 14 10",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_up-usage",
      toString: function () {
        return this.url;
      }
    }